import { createSvg } from '@r1-frontend/ui-react/components/svg/createSvg';

const TwentyFourSupport = (
    {
        strokeWidth = 1.5,
    },
): JSX.Element => {
    return (
        <>
            <g id={'contour'}>
                <path
                    d='M18 18.8597H17.24C16.44 18.8597 15.68 19.1697 15.12 19.7297L13.41 21.4198C12.63 22.1898 11.36 22.1898
                     10.58 21.4198L8.87 19.7297C8.31 19.1697 7.54 18.8597 6.75 18.8597H6C4.34 18.8597 3 17.5298 3 15.8898V4.97974C3
                     3.33974 4.34 2.00977 6 2.00977H18C19.66 2.00977 21 3.33974 21 4.97974V15.8898C21 17.5198 19.66 18.8597 18 18.8597Z'
                    strokeWidth={strokeWidth}
                    strokeMiterlimit='10'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M7 9.15979C7 8.22979 7.76 7.46973 8.69 7.46973C9.62 7.46973 10.38 8.22979 10.38 9.15979C10.38 11.0398
                     7.71 11.2398 7.12 13.0298C7 13.3998 7.31 13.7698 7.7 13.7698H10.38'
                    strokeWidth={strokeWidth}
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M16.04 13.7599V8.04991C16.04 7.78991 15.87 7.55985 15.62 7.48985C15.37 7.41985 15.1 7.51985 14.96
                     7.73985C14.24 8.89985 13.46 10.2199 12.78 11.3799C12.67 11.5699 12.67 11.8199 12.78 12.0099C12.89 12.1999 13.1 12.3198 13.33 12.3198H17'
                    strokeWidth={strokeWidth}
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
        </>
    );
};

export default createSvg(
    TwentyFourSupport,
    'twenty-four-support',
);
